import Component from '../core/Component'


const STATES = {
    ANIMATING: 'is-animating'
}

export default class AnimIcon extends Component {
    constructor(element, options = {}) {
        super(element, options)
        this.animationCount = 0
    }

    prepare() {
        this.element.addEventListener('mouseenter', this.handleMouseEnter)
    }


    handleMouseEnter = event => {
        this.runAnimation()
    }

    runAnimation() {
        if (this.is(STATES.ANIMATING)) {
            return
        }

        this.animationCount = 0
        this.element.addEventListener('animationstart', this.handleAnimationStart)
        this.element.addEventListener('animationend', this.handleAnimationEnd)
        this.element.classList.add(STATES.ANIMATING)
    }

    handleAnimationStart = event => {
        this.animationCount += 1
    }

    handleAnimationEnd = event => {
        this.animationCount -= 1

        if (this.animationCount > 0) {
            return
        }

        this.element.classList.remove(STATES.ANIMATING)
        this.element.removeEventListener('animationstart', this.handleAnimationStart)
        this.element.removeEventListener('animationend', this.handleAnimationEnd)
    }
}